<template>
    <div class="flex flex-col items-center">
        <button
            class="rounded-full bg-white w-16 h-16 flex flex-col items-center justify-center mb-2 border border-gray-300"
            @click.prevent="$emit('click')">
            <slot></slot>
        </button>

        <div class="w-[72px] line-clamp-2 text-center overflow-hidden" v-if="text?.length">
            {{ text }}
        </div>
    </div>
</template>

<script>

    export default {
        props: {
            text: {
                type: String,
                default: '',
            },
        },
    };
</script>

<style>
  .plus-icon {
    background-image: url(../../assets/image-plus@2x.png) !important;
  }

</style>